<template>
  <div v-if="SectInfo.ifSectShow">
    <div class="title">
      <b-row align-h="between">
        <b-col cols="10">
          <h6 class="mb-0">鄉鎮區段資訊</h6>
        </b-col>
      </b-row>
    </div>
    <div class="p-3" v-show="SectInfo.ifSectShow">
      <hr />
      <p>
        {{ SectInfo.townname || "" }}
      </p>
      <p>
        {{ SectInfo.sectname || "" }}
      </p>
      
    </div>
  </div>
</template>

<script>
// import VueDragResize from "vue-drag-resize";

export default {
  name: "DragSectInformationBox",
  data() {
    return {
      // <summary>
      //  變數宣告
      // </summary>
      ifSectShow: false,
      datetime: [],
      mergetime: "",
      codition: "",
      alertinformation: "",
      title: "",
      message: "",
      showdetail: true,
      disasterTile: [
        "",
        "颱風警戒",
        "焚風警戒",
        "降水警戒",
        "高溫警戒",
        "寒害警戒",
        "注意霪雨",
        "注意高溫",
        "注意寒害",
        "注意回溫",
        "注意降溫",
      ],
      yearSelected: "",
      periodSelected: "",
      resize: true,
      // infoheight: 600
    };
  },
  props: ["SectInfo"],
  // components: {
  //   VueDragResize,
  // },
  mounted() {
    // this.init()
    // this.checkPermission()
  },
  methods: {
    /*       <summary>
          關閉歷年作物查詢的視窗
        </summary>*/
    closeCropInfo() {
      this.$parent.closeCropInfo();
    },
    /*       <summary>
          關閉價量預警資料視窗
        </summary>*/
    closeTradeWarning() {
      this.$parent.closeTradeWarning();
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000003", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        this.showdetail = false;
      } else {
        this.showdetail = true;
      }
    },
    transDate(date) {
      let datearray = date.split("T")[0].split("-");
      let value = datearray[1] + "/" + datearray[2] + "日";
      return value;
    },
  },
};
</script>

<style>
.gis-info {
  height: auto;
  display: inline-block !important;
}
.p-3 {
  position: relative;
}
</style>
